import { call, put, takeEvery } from 'redux-saga/effects';

import * as types from './constants';
import * as actions from './actions';
import { handleErrors, fetch } from '../../../../api';
import api from '../../../../api/endpoints';

function* deleteGroup({ payload: { id, onSuccess } }) {

  try {
    const { data } = yield call(fetch, { api: api.modifiers.regularusers.remove, id });


    onSuccess && onSuccess();
    yield put(actions.deleteGroupDone(data.result));
  } catch (error) {
    yield handleErrors({
      error,
      putErrorData: actions.deleteGroupFailed,
      endpoint: api.modifiers.regularusers.remove.url
    });
  }
}

export const deleteGroupSaga = takeEvery(types.DELETE_GROUP_REQUEST, deleteGroup);